/**
 * Modal System
 * Handles opening/closing of native <dialog> modals with optional navigation
 */
export default class Modal {
	constructor() {
		this.init();
	}

	init() {
		// Open modal triggers
		document.addEventListener('click', (e) => {
			if (e.target.matches('.modal-trigger') || e.target.closest('.modal-trigger')) {
				e.preventDefault();
				const trigger = e.target.matches('.modal-trigger') ? e.target : e.target.closest('.modal-trigger');
				const modalId = trigger.dataset.modal;
				this.open(modalId);
			}
		});

		// Close modal handlers
		document.addEventListener('click', (e) => {
			if (e.target.matches('.modal-close') || e.target.closest('.modal-close')) {
				e.preventDefault();
				const closeBtn = e.target.matches('.modal-close') ? e.target : e.target.closest('.modal-close');
				const modal = closeBtn.closest('dialog');
				if (modal) {
					this.close(modal.id);
				}
			}
		});

		// Navigation: Previous
		document.addEventListener('click', (e) => {
			if (e.target.matches('.modal-nav-prev') || e.target.closest('.modal-nav-prev')) {
				e.preventDefault();
				const button = e.target.matches('.modal-nav-prev') ? e.target : e.target.closest('.modal-nav-prev');
				const currentModal = button.closest('dialog');
				this.navigatePrevious(currentModal);
			}
		});

		// Navigation: Next
		document.addEventListener('click', (e) => {
			if (e.target.matches('.modal-nav-next') || e.target.closest('.modal-nav-next')) {
				e.preventDefault();
				const button = e.target.matches('.modal-nav-next') ? e.target : e.target.closest('.modal-nav-next');
				const currentModal = button.closest('dialog');
				this.navigateNext(currentModal);
			}
		});

		// Close on backdrop click
		document.addEventListener('click', (e) => {
			if (e.target.matches('.op-modal')) {
				const rect = e.target.getBoundingClientRect();
				if (
					e.clientX < rect.left ||
					e.clientX > rect.right ||
					e.clientY < rect.top ||
					e.clientY > rect.bottom
				) {
					this.close(e.target.id);
				}
			}
		});

		// Close on Escape key
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				document.querySelectorAll('.op-modal[open]').forEach((modal) => {
					this.close(modal.id);
				});
			}
		});
	}

	// Public API methods for programmatic control
	open(modalId) {
		const modal = document.getElementById(modalId);
		if (modal) {
			modal.showModal();
			// Trigger reflow to ensure transition works
			modal.offsetHeight;
			modal.classList.add('is-open');

			if (modal.classList.contains('op-modal-nav')) {
				this.updateNavigationButtons(modal);
			}
		}
	}

	close(modalId) {
		const modal = document.getElementById(modalId);
		if (modal) {
			modal.classList.remove('is-open');
			setTimeout(() => {
				modal.close();
			}, 300); // Match your CSS transition duration
		}
	}

	closeAll() {
		document.querySelectorAll('.op-modal[open]').forEach((modal) => {
			this.close(modal.id);
		});
	}

	// Navigation methods
	navigateNext(currentModal) {
		if (!currentModal) return;

		const nextModal = currentModal.nextElementSibling;
		if (nextModal && nextModal.matches('.op-modal-nav')) {
			this.close(currentModal.id);
			setTimeout(() => {
				this.open(nextModal.id);
			}, 300); // Match transition duration
		}
	}

	navigatePrevious(currentModal) {
		if (!currentModal) return;

		const prevModal = currentModal.previousElementSibling;
		if (prevModal && prevModal.matches('.op-modal-nav')) {
			this.close(currentModal.id);
			setTimeout(() => {
				this.open(prevModal.id);
			}, 300); // Match transition duration
		}
	}

	updateNavigationButtons(modal) {
		if (!modal.classList.contains('op-modal-nav')) return;

		const prevBtn = modal.querySelector('.modal-nav-prev');
		const nextBtn = modal.querySelector('.modal-nav-next');

		if (!prevBtn || !nextBtn) return;

		// Check for previous sibling
		const prevModal = modal.previousElementSibling;
		if (prevModal && prevModal.matches('.op-modal-nav')) {
			prevBtn.style.display = '';
			prevBtn.disabled = false;
		} else {
			prevBtn.style.display = 'none';
			prevBtn.disabled = true;
		}

		// Check for next sibling
		const nextModal = modal.nextElementSibling;
		if (nextModal && nextModal.matches('.op-modal-nav')) {
			nextBtn.style.display = '';
			nextBtn.disabled = false;
		} else {
			nextBtn.style.display = 'none';
			nextBtn.disabled = true;
		}
	}
}
